var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('p',{staticStyle:{"background":"#fff"}},[_c('img',{attrs:{"src":require("../static/images/sili/S1.png"),"width":"100%","alt":"","srcset":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }